export default __webpack_public_path__ + "static/media/black-board.7a5beb69.svg";